import { gql, useQuery } from "@apollo/client";

const GET_VENUES = gql`
  query getVenues($memberId: ID!) {
    account {
      id
      member(id: $memberId) {
        clients {
          id
          accountName
          venues(memberId: $memberId) {
            id
            name
          }
        }
      }
    }
  }
`;

export const useMemberVenues = memberId => {
  const { data: venuesData, loading, error } = useQuery(GET_VENUES, {
    variables: {
      memberId
    },
    fetchPolicy: "network-only"
  });

  // Transform the data into a more usable format
  const venues =
    venuesData?.account?.member?.clients?.reduce((acc, client) => {
      const partnerVenues = client.venues.map(venue => ({
        ...venue,
        partnerId: client.id,
        partnerName: client.accountName
      }));
      return [...acc, ...partnerVenues];
    }, []) || [];

  return {
    venues,
    loading,
    error
  };
};
